import {FC} from 'react';
import {RegularModal} from '../RegularModal';
import style from './style.module.scss';
import {ButtonNew} from 'components/ButtonNew';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';
import NextLink from 'next/link';

interface IProps {
    onClose?: () => void;
}

export const PriveBonusesModal: FC<IProps> = ({onClose}) => {
    return (
        <RegularModal
            className={style.modal}
            onClose={onClose}
            hasClose={true}
            title={'Как работают бонусы'}
            classNameTitle={style.title}
            classNameContent={style.classNameContent}
            isMobileBottomAlign={true}
        >
            <div className={style.body}>
                <div className={style.items}>
                    <div className={style.item}>
                        <Icon icon={'bonuses-percent'} width={28} height={28} className={style.icon} />
                        <Typography variant={'body-16-r'} element={'p'}>
                            Возвращаем бонусными баллами <br />
                            5% от покупки в винотеках на карту лояльности
                        </Typography>
                    </div>

                    <div className={style.item}>
                        <Icon icon={'bonuses-payment'} width={28} height={28} className={style.icon} />
                        <Typography variant={'body-16-r'} element={'p'}>
                            Бонусами можно оплатить <br />
                            до 50% стоимости покупки с учетом текущих скидок на товары
                        </Typography>
                    </div>

                    <div className={style.item}>
                        <Icon icon={'bonuses-cart'} width={28} height={28} className={style.icon} />
                        <Typography variant={'body-16-r'} element={'p'}>
                            Списать бонусы можно при оформлении заказа на сайте, в приложении или в винотеке
                        </Typography>
                    </div>

                    <div className={style.item}>
                        <Icon icon={'bonuses-ruble'} width={28} height={28} className={style.icon} />
                        <Typography variant={'body-16-r'} element={'p'}>
                            Конвертация по системе
                            <br /> 1 бонус = 1 рубль
                        </Typography>
                    </div>
                </div>

                <NextLink href={'/catalog/vino'} className={style.catalogBtn}>
                    <ButtonNew variant={'large'} isStretched={true}>
                        Перейти в каталог
                    </ButtonNew>
                </NextLink>
                <ButtonNew
                    theme={'ghost'}
                    className={style.conditionsBtn}
                    href={'https://simplewine.ru/prive/loyaltyrules/'}
                    variant={'large'}
                >
                    Полные условия
                </ButtonNew>
            </div>
        </RegularModal>
    );
};
